export default "__VITE_ASSET__DavzjviK__"